<script>
import LoadBuildModal from "@/components/build/LoadBuildModal.vue";

export default {
  name: "SearchBuildModal",
  components: {LoadBuildModal},
  data() {
    return {
      showPopup: false,
    }
  },
  methods: {
    openPopup() {
      this.showPopup = true;
    },
    closePopup() {
      this.showPopup = false;
    }
  }
}
</script>

<template>
  <div>
    <button class="modal-trigger-button" @click.prevent="openPopup">
      {{ $t('hose.searchBuild') }}
    </button>

    <LoadBuildModal
        v-if="showPopup"
        @close="closePopup"
    ></LoadBuildModal>
  </div>
</template>

<style scoped lang="scss">
.modal-trigger-button {
  background-color: #3DB0C7;
  width: 100%;
  color: white;
  border: none;
  text-align: center;
  border-radius: 25px;
  padding: 9px;
  cursor: pointer;
  font-size: 12px;
  font-family: neue-haas-grotesk-display, sans-serif;
  transition: all 0.3s ease;

  &:focus {
    outline: none;
  }

  &:hover {
    background-color: darken(#3DB0C7, 10%);
  }
}
</style>